import React, { FC, useState } from 'react';

import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Col, InputNumber, Modal, Row } from 'antd';
import { config } from 'config/config';
import { CustomCloseIcon } from 'src/components/shoppingCart/ShoppingCart';
import { IShoppingProduct } from 'src/components/shoppingCart/ShoppingCart.utils';
import { IChallengeResourceConfig } from 'src/shared/models';

interface IProps {
  config: IChallengeResourceConfig;
  handleChangeQuantity: (idProduct: number, quantity: number) => void;
  product: IShoppingProduct;
}

const Product: FC<IProps> = ({
  config: cartConfig,
  handleChangeQuantity,
  product,
}) => {
  const {
    description: productDescription,
    idProduct,
    idResource,
    image,
    maxItems,
    minItems,
    name: productName,
    quantity,
  } = product;
  const [showImageModal, setShowImageModal] = useState(false);
  const productImage = image ? image : config.APP.BASE_URL + '/noimage.png';

  const increaseItems = () => {
    handleChangeQuantity(idResource, quantity + 1);
  };

  const reduceItems = () => {
    handleChangeQuantity(idResource, quantity - 1);
  };

  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    handleChangeQuantity(idResource, +evt.target.value);
  };

  const quantitySelector = !cartConfig.isCompleted && (
    <div className="product-input">
      <Row justify="center" align="middle" className="product-input-container">
        <Col span={7} onClick={reduceItems}>
          <MinusCircleOutlined />
        </Col>
        <Col span={10}>
          <InputNumber
            className="input-number"
            value={quantity}
            onBlur={handleBlur}
            min={minItems}
            max={maxItems}
          />
        </Col>
        <Col span={7} onClick={increaseItems}>
          <PlusCircleOutlined />
        </Col>
      </Row>
    </div>
  );

  const productComponent = (
    <div className="shopping-product">
      <div
        className="product-image-container"
        onClick={() => setShowImageModal(true)}
      >
        <img
          className="product-image"
          loading="lazy"
          alt={`product-${idProduct}`}
          src={productImage}
        />
        <div className="icon-container">
          <i className="icon icon--search"></i>
        </div>
      </div>
      <div className="product-name">{productName}</div>
      <div className="product-detail">
        <div dangerouslySetInnerHTML={{ __html: productDescription }} />
      </div>
      {quantitySelector}

      <Modal
        visible={showImageModal}
        footer={null}
        onCancel={() => setShowImageModal(false)}
        className="shopping-cart-modal view-product"
        closeIcon={<CustomCloseIcon />}
      >
        <Row
          justify="center"
          align="middle"
          className="shopping-cart-modal__row-col"
        >
          <img
            className="product-image"
            loading="lazy"
            alt={`product-${idProduct}`}
            src={productImage}
          />
          <div className="product-name">{productName}</div>
          <div className="product-detail">
            <div dangerouslySetInnerHTML={{ __html: productDescription }} />
          </div>
        </Row>
      </Modal>
    </div>
  );

  return productComponent;
};

export default Product;
